var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-map-div"},[_c('div',{staticClass:"my-map-div",attrs:{"id":_vm.mapId}}),_c('div',{attrs:{"id":_vm.mapId + 'Widget'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }